import { useEffect, useState } from 'react';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
	fallbackSrc: string;
}

export default function ImageWithFallback({ src, fallbackSrc, ...props }: ImageWithFallbackProps) {
	const [imgSrc, setImgSrc] = useState(fallbackSrc);

	useEffect(() => {
		setImgSrc(src);
	}, [src]);

	const handleError = () => {
		setImgSrc(fallbackSrc);
	};

	return <img loading="lazy" src={imgSrc || fallbackSrc} onError={handleError} {...props} />;
}
